$(() => {
    function swiperCatMobile() {
        if ($(window).width() < 1265) {
            var swiper_widecards = new Swiper('.swiper-container_popular', {
                scrollbar: {
                    el: '.swiper-container_popular .swiper-scrollbar',
                    draggable: true,
                },
                updateOnWindowResize: "true",
                breakpoints: {
                    1280: {
                        slidesPerView: 4,
                    },
                    1024: {
                        slidesPerView: 'auto',
                    },
                    768: {
                        slidesPerView: 'auto',
                    },
                    320: {
                        spaceBetween: 10,
                        slidesPerView: 'auto',
                    }
                },
                on: {
                    init: function (swiper) {
                        $(swiper.$el[0]).addClass("shown")
                    },
                },
            });
        }
    }

    swiperCatMobile();

    $(window).resize(function () {
        swiperCatMobile();

        if ($(window).outerWidth() <= 767) {

            resizeInstagram();
        }
    });

    function resizeInstagram() {
        var item_height = $('.inst-link:eq(0)').width();
        $('.inst-link').height(item_height);
    }
    if ($(window).outerWidth() <= 767) {
        resizeInstagram();
    }
});

document.querySelector('.video-box__video') && document.querySelector('.video-box__video')
    .addEventListener('click', ({ target }) => {
        target.paused && target.play() || target.pause()
    })
